export enum RequestStatuses {
  notAsked = 'NOT_ASKED',
  loading = 'LOADING',
  complete = 'COMPLETE',
  failed = 'FAILED',
}
